import React from 'react';
import { Box } from '@mui/material';

import { Loading } from 'components';
import { useUserNotifications } from 'store/apis/notifications';
import { OptionsGroup, OptionsGroupProps } from './options-group';

export const NotificationsForm = ({ userId, isCompact }: { userId?: number; isCompact?: boolean }) => {
  const {
    data: { operational: operationalNotifications, zone: zoneNotifications },
    isLoading: loading_userNotifications,
  } = useUserNotifications({ userId });

  const optionsGroups: OptionsGroupProps[] = [
    { title: 'Operational', options: operationalNotifications, userId, isCompact },
    { title: 'Zone', options: zoneNotifications, userId, isCompact },
  ];

  return (
    <Box>
      {loading_userNotifications ? (
        <Box
          sx={{
            paddingTop: 6,
          }}
        >
          <Loading text="Loading notification settings..." height={200} />
        </Box>
      ) : (
        optionsGroups.map((props, index) => <OptionsGroup key={`option-group-${index}`} {...props} />)
      )}
    </Box>
  );
};
